/*
* Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
* SPDX-License-Identifier: MIT
*
* Licensed under the MIT License. See the LICENSE accompanying this file
* for the specific language governing permissions and limitations under
* the License.
*/

import React from 'react';
import { I18n } from '@aws-amplify/core';

const LoginFormComment = () => {
	const paragraphs = I18n.get('SIGNIN_FORM_COMMENT')
		.split(/\n\n+/)
		.map((paragraph) => paragraph.trim())
		.filter(Boolean);

	if (paragraphs.length === 0) {
		return null;
	}

	return (
		<div className="login-form-comment" role="note">
			{paragraphs.map((paragraph, index) => (
				<p key={index}>{paragraph}</p>
			))}
		</div>
	);
};

export default LoginFormComment;
